import find from 'lodash/find';
import { CreditCardPaymentMethod, DetailsBooking, ListBooking } from 'types';
import { Total, PaymentMethod } from 'lib/graphql/generated';

export interface PendingScheduledPayment {
  deferredTo: string;
  total: Total;
  creditCardPaymentAllocation: {
    allocation: Total;
    paymentMethod: CreditCardPaymentMethod;
  };
}

export const getPendingScheduledPayment = (booking: DetailsBooking | ListBooking): PendingScheduledPayment | undefined => {
  if (!booking.flags.hasPendingScheduledPayment) {
    return undefined;
  }

  const upcomingScheduledPayment = find(booking.paymentSchedule, (paymentSchedule) => {
    return paymentSchedule.attempts.some((attempt) => attempt.status === 'PENDING');
  });
  const upcomingPendingPaymentAttempt = find(upcomingScheduledPayment?.attempts, { status: 'PENDING' });
  const creditCardPaymentAllocation = find(
    upcomingPendingPaymentAttempt?.paymentAllocations,
    (allocation) => (allocation.paymentMethod as PaymentMethod).method === 'credit_card',
  )!;

  return (
    upcomingScheduledPayment && {
      deferredTo: upcomingScheduledPayment.deferredTo,
      total: upcomingScheduledPayment.total,
      creditCardPaymentAllocation: {
        allocation: creditCardPaymentAllocation.allocation,
        paymentMethod: creditCardPaymentAllocation.paymentMethod as CreditCardPaymentMethod,
      },
    }
  );
};
